// extracted by mini-css-extract-plugin
module.exports = {"statItems":"styles_statItems__tLyT5","statItem":"styles_statItem__GT1Yh","statItemName":"styles_statItemName__5CIUn","dot":"styles_dot__71YMa"};